import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/videos';

export default function FeaturesSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择人人影视
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            {siteInfo.slogan}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {siteInfo.features.map((feature, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 
                hover:border-primary-200 transition-all duration-300 group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 mb-4 
                group-hover:bg-primary-500 transition-colors">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
          <div className="text-center p-4">
            <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{siteInfo.stats.totalVideos}</div>
            <p className="text-xs text-foreground-400 mt-1">影视资源</p>
          </div>
          <div className="text-center p-4">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">{siteInfo.stats.dailyActive}</div>
            <p className="text-xs text-foreground-400 mt-1">日活用户</p>
          </div>
          <div className="text-center p-4">
            <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{siteInfo.stats.totalUsers}</div>
            <p className="text-xs text-foreground-400 mt-1">累计用户</p>
          </div>
          <div className="text-center p-4">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">{siteInfo.stats.satisfaction}</div>
            <p className="text-xs text-foreground-400 mt-1">用户满意度</p>
          </div>
        </div>
      </div>
    </section>
  );
}